<template>
    <FacetContainer title="Project" :facets="facets" @selected="selected" @deselected="deselected"></FacetContainer>
</template>

<script>

import FacetContainer from '@/components/widgets/FacetContainer.vue';
import axios from 'axios';

export default {

    data() {
        return {
            facets: []
        }
    },

    components: {
        FacetContainer
    },

    methods: {
        refresh_facets() {
            axios.get('/mtm-gateway-api/v1/services/crawlers-admin/projects')
            .then((res) => {
                res.data.projects.forEach((project) => {
                    this.facets.push({
                        name: 'project_id',
                        value: project.project_name
                    });
                });
            });
        },
        selected(facet) {
            this.$emit('selected', facet);
        },
        deselected(facet) {
            this.$emit('deselected', facet);
        }
    },

    created() {
        this.refresh_facets();
    }
};

</script>
